// Return-url flow tracing. Enable via REACT_APP_DEBUG_RETURN_URL=true for debugging.
export const DEBUG_RETURN_URL_FLOW =
  process.env.NODE_ENV !== "test" &&
  process.env.REACT_APP_DEBUG_RETURN_URL === "true";

export function logReturnUrlFlow(step, details = {}) {
  if (!DEBUG_RETURN_URL_FLOW) return;
  console.log(`[return-url] ${step}`, details);
}
